module.exports = __webpack_public_path__ + "static/media/10.118da113.png";